import axios from "axios";

const downloadFile = async (fileUrl, name) => {
  const response = await axios({
    url: fileUrl,
    method: "GET",
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", name);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default downloadFile;
